import React from "react";
import "./homepageHeader.css";
import NavBar from "../../Layout/NavBar/NavBar";
import { useEffect } from "react";
import { useState } from "react";
import video from "../../Assets/video.mp4";
import useViewport from "../../Common/GetViewPort";
import { Navigate, useNavigate } from "react-router-dom";

const HomepageHeader = (props) => {
  const navigate = useNavigate();
  const width = useViewport().width;
  const t = props.language;
  const btnArray = [
    t("meet_team"),
    t("discover_portfolio"),
    t("latest_news"),
    t("history"),
  ];
  const [index, setIndex] = useState(0);
  useEffect(() => {}, [width]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIndex(index + 1);
      if (index === btnArray.length - 1) {
        setIndex(0);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="header">
      {!props.openMenu ? (
        <>
          <div style={{ backgroundColor: "transparent" }}>
            {width >= 768 ? (
              <video
                autoPlay
                muted
                loop
                // className="background-image"
                width={"100%"}
                height={"100%"}
              >
                <source src={video} type="video/mp4"></source>
              </video>
            ) : (
              <div className="background-image">
                <h1></h1>
              </div>
            )}
          </div>
          <div className="background-text">
            <span className="underline">
              Black Swan Real Estate Capital{" "}
              <span style={{ color: "white" }}>{t("bsr")}</span>
            </span>
            {/* <span>{t("gestion")}</span> */}
            {[1, 2, 3].includes(index) ? (
              <a
                href={
                  index - 1 === 0 ? "#team" : index - 1 === 3 ? "#know-how" : ""
                }
                className="invest-btn"
                onClick={() => {
                  if (index - 1 === 1) {
                    navigate("/our-portfolio");
                  }
                }}
              >
                {btnArray[index - 1]}
              </a>
            ) : (
              <a href="#know-how" className="invest-btn">
                {t("history")}
              </a>
            )}
          </div>
        </>
      ) : (
        <div></div>
      )}

      {/* <div className="header__overlay"></div> */}
    </div>
  );
};

export default HomepageHeader;
